import React from 'react'
import { Button, withStyles } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import styles from './styles'
import language from 'utils/vast-languagepack'

export default withStyles(styles)(({ classes, history }) => (
  <Button
    style={{marginBlockStart: '0.67em', marginBlockEnd: '0.3em', borderRadius: '20px'}}
    className={classes.addButton}
    onClick={() => history.push('/forms/new')}
  >
    <Add /> {language.signupform.createForm}
  </Button>
));
